/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import _ from 'lodash';

import * as lc from '../../../../../utils/lodashCustom';

export function restructureUserAnketaForm(data) {
  const birthDt = lc.get(data, 'birth_dt');
  return {
    name: lc.get(data, 'name'),
    gender: lc.get(data, 'gender'),
    time_zone: lc.get(data, 'time_zone'),
    date: birthDt ? moment(birthDt).date() : null,
    month: birthDt ? moment(birthDt).month() + 1 : null,
    year: birthDt ? moment(birthDt).year() : null,
    city_geoname_id: lc.get(data, 'city_geoname_id'),
    consent_to_adult_content: lc.get(data, 'consent_to_adult_content'),
    cityGeonameDesc: _.get(data, 'city_geo_name')
      ? lc.get(data, 'city_geo_name.locale')
      : null
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/services/UserProfileService/restructuring/index.js